import { Card, useWindowWidth } from '@acceso/design-system';
import clsx from 'clsx';
import { useState } from 'react';

import { MOBILE_WIDTH } from '@/constants';

import { TFeaturedPeopleType } from '../../types';

import { FeaturedPeopleDetail } from './components';

type FeaturedPeopleDetailsCardProps = {
  featuredPeople: TFeaturedPeopleType;
  isCollapsed: boolean;
  onCollapse: () => void;
  onUpdate: (featuredPeople: TFeaturedPeopleType) => void;
};

export function FeaturedPeopleDetailCard({
  isCollapsed,
  featuredPeople,
  onCollapse,
  onUpdate,
}: FeaturedPeopleDetailsCardProps) {
  const { width } = useWindowWidth();
  const isMobile = width < MOBILE_WIDTH;
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card
      className="w-full"
      title={featuredPeople.name}
      isAccordion={isMobile}
      isCollapsable={!isMobile}
      isOpen={isOpen}
      collapseDirection="right"
      lineSeparator={true}
      isCollapsed={isCollapsed && !isMobile}
      onCollapse={onCollapse}
      onOpen={() => setIsOpen(!isOpen)}
      classes={{
        header: clsx(!isMobile && 'py-3'),
      }}
    >
      <div className="body flex flex-col gap-size-12 self-stretch">
        <FeaturedPeopleDetail featuredPeople={featuredPeople} onUpdate={onUpdate} />
      </div>
    </Card>
  );
}
